import { useCallback, useState } from "react";

import { readApiStatus, readHumanErrorMessage } from "@/shared/utils/apiError";

import { CardholderOnboardingService } from "../services/cardholderOnboarding.service";

/** `POST /identities/:id/retry-provider` — the backend admits only identities still in `PENDING_REVIEW`. */
export function useRetryRegistration(organizationId: string | null) {
  const [retryingId, setRetryingId] = useState<string | null>(null);

  const retry = useCallback(
    async (
      identityId: string,
      fallbackError: string,
    ): Promise<{ ok: true } | { ok: false; message: string }> => {
      if (!organizationId) return { ok: false, message: fallbackError };
      setRetryingId(identityId);
      try {
        await CardholderOnboardingService.retryRegistration(identityId, organizationId);
        return { ok: true };
      } catch (err) {
        const status = readApiStatus(err);
        return {
          ok: false,
          message:
            status !== null && status >= 500 ? fallbackError : readHumanErrorMessage(err, fallbackError),
        };
      } finally {
        setRetryingId(null);
      }
    },
    [organizationId],
  );

  return { retry, retryingId };
}
